package com.essntl.features.message.ui

import com.essntl.uikit.components.chat.contact.ContactUiState

sealed interface MessageNavigation {
    data class ClientProfile(
        val clientPhoneNumber: String,
        val contactUiState: ContactUiState,
    ) : MessageNavigation

    data object CloseSidePanel : MessageNavigation
}